const norm = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');

export function matchBurgerprintsOption(wanted, values = []) {
  const list = (values || []).filter(Boolean);
  if (!list.length || wanted == null || String(wanted).trim() === '') return '';
  const needle = norm(wanted);
  const exact = list.find((value) => norm(value) === needle);
  if (exact) return exact;
  const partial = list.filter((value) => {
    const hay = norm(value);
    return hay.includes(needle) || needle.includes(hay);
  });
  return partial.length === 1 ? partial[0] : '';
}

export function colorsForSize(variants = [], size) {
  const rows = size
    ? variants.filter((variant) => norm(variant.size) === norm(size))
    : variants;
  return [...new Set(rows.map((variant) => variant.color).filter(Boolean))];
}

export function sizesForColor(variants = [], color) {
  const rows = color
    ? variants.filter((variant) => norm(variant.color) === norm(color))
    : variants;
  return [...new Set(rows.map((variant) => variant.size).filter(Boolean))];
}

export function findBurgerprintsVariant(variants = [], size, color) {
  if (!size || !color) return null;
  return variants.find((variant) => norm(variant.size) === norm(size) && norm(variant.color) === norm(color)) || null;
}

const STYLE_TO_SHORT = {
  G5000: 'USG5000',
  G5000L: 'USGG5000L',
  G5000B: 'USG5000B',
  G18500: 'USG18500',
  G18500B: 'USG18500B',
  G18000: 'USG18000',
  G18000B: 'USGG18000B',
  G5200: 'USG5200',
  G5V00L: 'USGG5V00L',
  G64V00DTG: 'USG64V00',
  BC3001: 'USBC3001',
  BC3001Y: 'USGBC3001Y',
  BC3005: 'USBC3005',
  BC3480: 'USNC3480',
  CC1717: 'USCC1717',
  CC9018: 'USCC9018',
  CC9360: 'USUFCC9360',
};

function orderText(orderItem) {
  return `${orderItem?.size || ''} ${orderItem?.items_name || ''} ${orderItem?.sku || ''}`.toLowerCase();
}

function keywordShortCode(text) {
  const youth = /\byouth\b|\bkid\b|\bkids\b/.test(text);
  const women = /\b(woman|women|ladies|lady)\b/.test(text);
  const hoodie = /hoodie/.test(text);
  const sweat = /sweatshirt|sweat shirt|crewneck/.test(text);
  const tank = /\btank\b/.test(text);
  const vneck = /v-?neck/.test(text);
  const bella = /bella/.test(text);
  const comfort = /comfort/.test(text);
  const tee = /\btee\b|t-?\s?shirt/.test(text);

  if (hoodie && youth) return 'USG18500B';
  if (hoodie && comfort) return 'USCC1567';
  if (hoodie) return 'USG18500';
  if (sweat && youth) return 'USGG18000B';
  if (sweat && comfort) return 'USCC1566';
  if (sweat) return 'USG18000';
  if (tank && comfort) return 'USUFCC9360';
  if (tank && bella) return 'USNC3480';
  if (tank) return 'USG5200';
  if (vneck && women) return 'USGG5V00L';
  if (vneck && bella) return 'USBC3005';
  if (vneck) return 'USG64V00';
  if (youth && tee && comfort) return 'USCC9018';
  if (youth && tee && bella) return 'USGBC3001Y';
  if (youth && tee) return 'USG5000B';
  if (women && tee) return 'USGG5000L';
  if (comfort && tee) return 'USCC1717';
  if (bella && tee) return 'USBC3001';
  if (/\bgildan\b/.test(text) && tee) return 'USG5000';
  if (tee && !/aop|3d|jersey|hawaiian|polo/.test(text)) return 'USG5000';
  return '';
}

export function suggestBurgerprintsShortCode(orderItem, detectedStyleCode = '') {
  const text = orderText(orderItem);
  if (text.includes('crocs') || String(orderItem?.size || '').includes('Size: US')) return '';
  if (/colortone|color tone/.test(text)) return /\btank\b/.test(text) ? 'USUFCC9360' : 'USC1300';
  const mapped = STYLE_TO_SHORT[String(detectedStyleCode || '').trim()];
  if (mapped) return mapped;
  return keywordShortCode(text);
}
